import React, { useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { useLocation, useNavigate } from "react-router-dom";

import Sidebar from "../components/layout/Sidebar";
import Topbar from "../components/layout/Topbar";

import { sendInternalNotification } from "../utils/sendInternalNotification";

import "./VerificacaoDetalhe.css";

export default function VerificacaoDetalhe() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // ==========================================
  // 🚨 Proteção contra acesso direto
  // ==========================================
  useEffect(() => {
    if (!state || !state.uid) {
      alert("Dados incompletos da verificação.");
      navigate("/verificacoes-pendentes");
    }
  }, [state, navigate]);

  if (!state) return null;

  // ==========================================
  // ✓ Aprovar verificação
  // ==========================================
  async function aprovar() {
    try {
      await updateDoc(doc(db, "users", state.uid), {
        verificationStatus: "verified",
        verificationReviewedAt: new Date(),
      });

      // 🔔 Notificação interna
      await sendInternalNotification(
        state.uid,
        "🎉 Sua verificação foi aprovada!",
        "Parabéns! Seu perfil agora possui o selo de verificado no One Love. Obrigado por tornar nossa comunidade mais segura e verdadeira! 💗"
      );

      alert("Verificação aprovada!");
      navigate("/verificacoes-pendentes");
    } catch (e) {
      console.error("Erro ao aprovar:", e);
      alert("Erro ao aprovar verificação.");
    }
  }

  // ==========================================
  // ✗ Rejeitar verificação
  // ==========================================
  async function rejeitar() {
    try {
      await updateDoc(doc(db, "users", state.uid), {
        verificationStatus: "rejected",
        verificationReviewedAt: new Date(),
      });

      await sendInternalNotification(
        state.uid,
        "Sua verificação não foi aprovada 😕",
        "Sua foto ou frase não estava de acordo com as instruções. Mas você pode tentar novamente quando quiser! Estamos aqui para ajudar 💗"
      );

      alert("Verificação rejeitada.");
      navigate("/verificacoes-pendentes");
    } catch (e) {
      console.error("Erro ao rejeitar:", e);
      alert("Erro ao rejeitar verificação.");
    }
  }

  return (
    <div className="page-container">
      <Sidebar />

      <div className="page-content">
        <Topbar />

        <h2 className="veri-title">Analisar Verificação</h2>

        <div className="veri-card">
          <div className="veri-info">
            <p><strong>Nome:</strong> {state.name}</p>
            <p><strong>Profissão:</strong> {state.profession || "Não informado"}</p>

            <p><strong>Frase enviada:</strong></p>
            <blockquote className="veri-quote">
              {state.verifyPhrase || "—"}
            </blockquote>

            <p><strong>UID:</strong> {state.uid}</p>
            <p><strong>Data do envio:</strong> {state.createdAt || "—"}</p>
          </div>

          <div className="veri-image-wrapper">
            <img
              src={state.verifySelfieUrl}
              alt="Selfie"
              className="veri-image"
            />
          </div>

          <div className="veri-actions">
            <button className="btn-approve" onClick={aprovar}>
              ✓ Aprovar
            </button>

            <button className="btn-reject" onClick={rejeitar}>
              ✗ Rejeitar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
